import { X, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const EditLoyaltyModal = ({ 
  customer, 
  value, 
  onChange, 
  onSave, 
  onClose 
}) => {
  if (!customer) return null;

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl w-full max-w-sm shadow-2xl">
        <div className="flex items-center justify-between p-4 border-b">
          <h3 className="font-bold text-lg">Modifier la progression</h3>
          <Button variant="ghost" size="icon" onClick={onClose}>
            <X className="w-5 h-5" />
          </Button>
        </div>
        <div className="p-4">
          <div className="mb-4 p-3 bg-slate-50 rounded-lg">
            <p className="font-medium">{customer.first_name} {customer.last_name}</p>
            <p className="text-sm text-slate-500">
              Progression actuelle: {(customer.loyalty_balance || 0).toFixed(2)}€ / 50€
            </p>
          </div>
          
          <div className="mb-4">
            <Label>Nouvelle progression (€)</Label>
            <Input
              type="number"
              step="0.01"
              min="-50"
              max="49.99"
              placeholder="Ex: 25.50 ou -5"
              value={value}
              onChange={(e) => onChange(e.target.value)}
              className="mt-1"
              autoFocus
            />
            <p className="text-xs text-slate-500 mt-1">
              Peut être négatif si le client a une dette fidélité
            </p>
          </div>
          
          <div className="flex gap-2">
            <Button variant="outline" className="flex-1" onClick={onClose}>
              Annuler
            </Button>
            <Button className="flex-1 bg-pink-500 hover:bg-pink-600" onClick={onSave}>
              <Check className="w-4 h-4 mr-1" />
              Enregistrer
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditLoyaltyModal;
